/* eslint-disable react/no-unused-prop-types */
import { shape, string } from 'prop-types';
import { t } from '@lingui/macro';
import { defaultsDeep, get, identity } from 'lodash';

import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropTypes } from '../../page-framework/filter/FilterPropTypes';
import EntityListFilter, { useEntity, useEntityName } from '../entity-list-filter/EntityListFilter';
import getEntityListFilterStateServiceFactory from '../entity-list-filter/EntityListFilterStateService';
import { ENTITY_TYPES } from '../../../services/EntityService';
import { filterId as vmFilterId } from '../virtual-machine-filter/VirtualMachineFilter';
import { filterId as hypervisorFilterId } from '../hypervisor-filter/HypervisorFilter';

export const filterId = 'Server';
export const filterTitle = t`Server`;
export const entityType = ENTITY_TYPES.SERVER;

export function useServer() {
    return useEntity(filterId);
}

export function useServerName() {
    return useEntityName(filterId);
}

const columns = [
    {
        title: 'Name',
        mapping: 'name',
        flex: 1,
        minWidth: 250,
        sortable: true,
        resizable: false,
    },
    {
        title: 'IP Address',
        width: 150,
        flex: 1,
        sortable: true,
        mapping: 'ipAddress',
    },
];

const dataSourceParams = {
    entityFields: ['name', 'ipAddress'],
};

function ServerFilter(props) {
    const { state, filterActions } = props;
    const options = { entityType, columns, dataSourceParams, showHeaders: true };
    return <EntityListFilter options={options} state={state} filterActions={filterActions} />;
}

ServerFilter.propTypes = {
    id: filterPropTypes.id,
    title: filterPropTypes.title,
    filterActions: filterPropTypes.filterActions,
    state: shape({
        uuid: string.isRequired,
        name: string.isRequired,
    }),
};

ServerFilter.defaultProps = defaultsDeep(
    {
        options: {
            link: (server) => {
                const subType = get(server, 'subType');
                let subTypeTarget;
                let subTypeFilterId;
                switch (subType) {
                    case 'virtualmachine':
                        subTypeTarget = 'vmware-vm-detail';
                        subTypeFilterId = vmFilterId;
                        break;
                    case 'hypervisor':
                        subTypeTarget = 'vmware-host-detail';
                        subTypeFilterId = hypervisorFilterId;
                        break;
                    default:
                        subTypeTarget = 'server-detail';
                        subTypeFilterId = filterId;
                }
                return defaultsDeep(
                    {
                        target: subTypeTarget,
                        mappedFilterParams: {
                            [subTypeFilterId]: identity,
                        },
                    },
                    EntityListFilter.defaultProps.options.link
                );
            },
        },
        id: filterId,
        title: filterTitle,
        state: undefined,
    },
    EntityListFilter.defaultProps
);

export default Filter({
    filterId,
    filterStateServiceFactory: getEntityListFilterStateServiceFactory(filterTitle, entityType),
})(ServerFilter);
